module.exports = __webpack_public_path__ + "static/chaboni-e4ab33fb5a0b9031732ae90e365881ec.png";